module.exports = __webpack_public_path__ + "img/19@2x.20fff175.png";